import React from 'react';

import {getHigherOrderComponentName} from '../../utils/component';
import {runDatePickerSelectDateHintExperiment} from '../../utils/experiments';

function withSearchDayTemplate(DayTemplate, abacusStore, datesTranslations) {
    function getTemplateProps() {
        let templateProps = {};

        if (runDatePickerSelectDateHintExperiment({shouldLogExperiment: false}, abacusStore)) {
            const {
                selectDateHintMessage
            } = datesTranslations;

            templateProps = {
                ...templateProps,
                selectDateHintMessage
            };
        }

        return templateProps;
    }

    const templateProps = getTemplateProps();

    function SearchDayTemplate(instanceProps) {
        return (
            <DayTemplate
                {...templateProps}
                {...instanceProps}
            />
        );
    }

    Object.assign(SearchDayTemplate, DayTemplate);

    SearchDayTemplate.displayName = getHigherOrderComponentName(SearchDayTemplate, DayTemplate, {
        defaultWrapperComponentName: 'SearchDayTemplate',
        defaultWrappedComponentName: 'DayTemplate'
    });

    return SearchDayTemplate;
}

export {withSearchDayTemplate};
